import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { HypersceneAdvancedDemo } from '../../hyperscene-advanced.component';

/**
 * The Viewpoints tab: saved camera views of the scene and their links. The page owns the state; this component only
 * renders it, so it is checked with the page.
 */
@Component({
  selector: 'section[viewer-viewpoints-panel]',
  templateUrl: './viewer-viewpoints-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewerViewpointsPanelComponent {
  @Input({ required: true }) public viewer!: HypersceneAdvancedDemo;
}
